import { render, staticRenderFns } from "./rule-card.vue?vue&type=template&id=6c4f4abf&"
import script from "./rule-card.vue?vue&type=script&lang=js&"
export * from "./rule-card.vue?vue&type=script&lang=js&"
import style0 from "./rule-card.vue?vue&type=style&index=0&id=6c4f4abf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports